module.exports = __webpack_public_path__ + "static/media/pattern.3a684586.png";